import {
  GET_RATING,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialRating = {
  reviewData: [],
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const ratingReducer = (state = initialRating, action) => {
  switch (action.type) {
    case GET_RATING:
      return {
        ...state,
        rating: action.payload.rates.map((rate) => {
          return {
            ...rate,
            productTitle: rate.product.title,
            updatedAtFormatted: moment(rate.createdAt).format("ll"),
          };
        }),
        ratingCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default ratingReducer;
